import moment from 'moment';

const isValidElectionDate = (value) => {
  if (!value) {
    return false;
  }

  const parsed = moment.utc(value);
  return parsed.isValid() && parsed.year() > 1;
};

export const isElectionStatusToggleDisabled = ({
  locked,
  startActiveAt,
  endActiveAt,
  now = moment.utc(),
}) => {
  if (!locked || !isValidElectionDate(startActiveAt) || !isValidElectionDate(endActiveAt)) {
    return false;
  }

  const currentDate = moment.utc(now).startOf('day');
  const startDate = moment.utc(startActiveAt).startOf('day');
  const endDate = moment.utc(endActiveAt).endOf('day');

  return currentDate.isSameOrAfter(startDate) && currentDate.isSameOrBefore(endDate);
};
